import { render, staticRenderFns } from "./wode-shoucang.vue?vue&type=template&id=27cd1f46&"
import script from "./wode-shoucang.vue?vue&type=script&lang=js&"
export * from "./wode-shoucang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports